import Avatar from '@mui/material/Avatar';

type MemberAvatarProps = {
  firstName: string;
  lastName: string;
};

const MemberAvatar = (props: MemberAvatarProps) => {
  const { firstName, lastName } = props;

  const stringToColor = (string: string) => {
    let hash = 0;
    let i;

    /* eslint-disable no-bitwise */
    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }
    /* eslint-enable no-bitwise */

    return color;
  };
  enum AvatarSizes {
    xs = 60,
    sm = 80,
    md = 120,
  }

  const stringAvatar = (fName: string, lName: string) => {
    return {
      sx: {
        bgcolor: stringToColor(`${fName} ${lName}`),
        width: {
          xs: AvatarSizes.xs,
          sm: AvatarSizes.sm,
          md: AvatarSizes.md,
        },
        height: {
          xs: AvatarSizes.xs,
          sm: AvatarSizes.sm,
          md: AvatarSizes.md,
        },
        fontSize: {
          xs: AvatarSizes.xs / 2,
          sm: AvatarSizes.sm / 2,
          md: AvatarSizes.md / 2,
        },
      },
      children: `${fName.length > 0 ? fName.charAt(0) : ''}${lName.length > 0 ? lName.charAt(0) : ''}`,
    };
  };

  return <Avatar {...stringAvatar(firstName, lastName)} />;
};

export default MemberAvatar;
